"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _Radio = _interopRequireDefault(require("@material-ui/core/Radio"));

var _RadioGroup = _interopRequireDefault(require("@material-ui/core/RadioGroup"));

var _propTypes = require("prop-types");

var _formTypes = require("../../types/formTypes");

var _WithTheme = _interopRequireDefault(require("../WithTheme"));

var _theme = require("./theme");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var UTRadioGroup = /*#__PURE__*/function (_PureComponent) {
  _inherits(UTRadioGroup, _PureComponent);

  function UTRadioGroup() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, UTRadioGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(UTRadioGroup)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (_, value) {
      return _this.props.input.onChange(value);
    });

    _defineProperty(_assertThisInitialized(_this), "renderRadioItem", function (option, index) {
      var _this$props = _this.props,
          classes = _this$props.classes,
          valueKey = _this$props.valueKey,
          labelKey = _this$props.labelKey,
          disabled = _this$props.disabled,
          className = _this$props.className;
      return _react["default"].createElement(_FormControlLabel["default"], {
        key: option[valueKey],
        value: option[valueKey],
        classes: {
          root: classes.root,
          label: classes.label
        },
        disabled: disabled,
        label: option[labelKey],
        control: _react["default"].createElement(_Radio["default"], null),
        className: "".concat(classes.formControlLabel, " \n              ").concat(_this.props.divider && index === 0 && classes.topDivider, " \n              ").concat(_this.props.divider && classes.divider, "\n              ").concat(className)
      });
    });

    return _this;
  }

  _createClass(UTRadioGroup, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          input = _this$props2.input,
          options = _this$props2.options;
      return _react["default"].createElement(_RadioGroup["default"], {
        name: input.name,
        value: input.value,
        onChange: this.handleChange
      }, options.map(this.renderRadioItem));
    }
  }]);

  return UTRadioGroup;
}(_react.PureComponent);

UTRadioGroup.defaultProps = {
  valueKey: 'value',
  labelKey: 'name',
  classes: {}
};
UTRadioGroup.propTypes = {
  input: _formTypes.inputPropTypes,
  options: (0, _propTypes.arrayOf)((0, _propTypes.shape)(_propTypes.any)),
  valueKey: _propTypes.string,
  labelKey: _propTypes.string,
  divider: _propTypes.bool,
  disabled: _propTypes.bool,
  className: _propTypes.string,
  classes: _propTypes.object // eslint-disable-line react/forbid-prop-types

};

var _default = (0, _WithTheme["default"])(_theme.retrieveStyle, _theme.retrieveMuiTheme)(UTRadioGroup);

exports["default"] = _default;